import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/axios';

import { directive as onClickOutside } from 'vue-on-click-outside';

// Main menu icons
import 'vue-awesome/icons/home';
import 'vue-awesome/icons/calendar-check';
import 'vue-awesome/icons/cog';
import 'vue-awesome/icons/user';
import 'vue-awesome/icons/file-alt';
import 'vue-awesome/icons/sign-out-alt';

// Settings icons
import 'vue-awesome/icons/arrows-alt';
import 'vue-awesome/icons/building';
import 'vue-awesome/icons/users-cog';
import 'vue-awesome/icons/handshake';
import 'vue-awesome/icons/sliders-h';
import 'vue-awesome/icons/file';

// Other icons
import 'vue-awesome/icons/edit';
import 'vue-awesome/icons/check';
import 'vue-awesome/icons/times';
import 'vue-awesome/icons/trash';
import 'vue-awesome/icons/search';
import 'vue-awesome/icons/angle-down';
import 'vue-awesome/icons/calendar-alt';
import 'vue-awesome/icons/paper-plane';
import 'vue-awesome/icons/download';

import Icon from 'vue-awesome/components/Icon';
import Toasted from 'vue-toasted';
import VueDatePicker from '@mathieustan/vue-datepicker';

Vue.use(Toasted, {
  position: 'top-center',
  duration: 2000,
  keepOnHover: true,
  theme: 'bubble',
  router,
});

Vue.use(VueDatePicker, {
  lang: 'ru',
});

Vue.directive('on-click-outside', onClickOutside);

Vue.component('v-icon', Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
